import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { UserInfoResponse } from "@/api/types";

interface UserState {
  userInfo: UserInfoResponse | null;
  setUserInfo: (userInfo: UserInfoResponse | null) => void;
  clearUserInfo: () => void;
}

/**
 * 用户信息全局状态管理
 * 使用 Zustand + persist 实现状态持久化
 */
export const useUserStore = create<UserState>()(
  persist(
    set => ({
      userInfo: null,

      // 设置用户信息
      setUserInfo: userInfo => set({ userInfo }),

      // 清除用户信息
      clearUserInfo: () => set({ userInfo: null }),
    }),
    {
      name: "user-storage", // localStorage 中的 key
    }
  )
);
